export const CATEGORY_ID_WORLD_SERIES = 6601;
